import { path } from 'ramda'

import type { Path } from 'ramda'

function sortByDate<T = Record<string, unknown>>(fieldName: Path, direction: 'ASC' | 'DESC' = 'ASC') {
  return (a: T, b: T) => {
    const aTimeValue = new Date(path(fieldName, a) as string)?.getTime()
    const bTimeValue = new Date(path(fieldName, b) as string)?.getTime()
    return direction === 'ASC' ? aTimeValue - bTimeValue : bTimeValue - aTimeValue
  }
}

export { sortByDate }
